import React, { useState } from "react";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";
import { FaAngleUp, FaAngleDown } from "react-icons/fa";

const AccordionContainer = styled.div`
  margin-bottom: 10px;
  transition: border 0.6s ease-in-out;

  ${({ isActive }) =>
    isActive &&
    css`
      border-bottom: solid 1px rgba(255, 255, 255, 0.25);
      margin-bottom: 20px;
    `}
`;

const AccordionTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  cursor: pointer;
  text-transform: uppercase;
  font-size: 17px;
  padding: 0 20px;
  margin-bottom: 20px;
  font-weight: 700;
  text-decoration: none;
  color: white;
  cursor: pointer;
  transition: color 0.3s linear;

  &:hover {
    color: #3fa9f5;
  }
`;
const AccordionContent = styled.ul`
  color: #e5e5e5;
  font-size: 16px;
  font-weight: 500;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.6s ease-in-out;
  margin: 0;

  ${({ isActive }) =>
    isActive &&
    css`
      max-height: 2000px;
    `}
`;

const Item = styled.li`
  list-style: none;
  margin-bottom: 10px;
`;

const Accordion = ({ title, accordionItems }) => {
  const [isActive, setIsActive] = useState(false);
  return (
    <AccordionContainer isActive={isActive} data-test="accordion-container">
      <AccordionTitle
        onClick={() => setIsActive(!isActive)}
        data-test="accordion-title"
      >
        <div>{title}</div>
        {isActive ? (
          <FaAngleUp fontSize={"22px"} data-test="fa-angle-up" />
        ) : (
          <FaAngleDown fontSize={"22px"} />
        )}
      </AccordionTitle>
      <AccordionContent isActive={isActive} data-test="accordion-content">
        {accordionItems.map((item, idx) => (
          <Item key={idx}>{item}</Item>
        ))}
      </AccordionContent>
    </AccordionContainer>
  );
};

Accordion.propTypes = {
  title: PropTypes.string.isRequired,
  accordionItems: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Accordion;
